import type {
  BiddingBlockApprovalRequest,
  BiddingBlockBid,
} from '@ebalance/proto/bffuser/v1/bidding_block_model_pb'

import type { VolumeCountableBid } from './spotBidValidation'

/**
 * ブロック入札の group を、 述語を満たす leg のコマ別数量に展開する (leg はコマ別に
 * 数量が異なり得る〈AC-BSP-030a〉ので、 time slot 1 件を 1 entry にする)。
 */
export const expandBlockLegSlots = (
  requests: readonly BiddingBlockApprovalRequest[],
  includeLeg: (
    group: BiddingBlockApprovalRequest,
    leg: BiddingBlockBid,
  ) => boolean,
): VolumeCountableBid[] =>
  requests.flatMap((g) =>
    [g.primary, g.secondary]
      .filter((leg): leg is BiddingBlockBid => leg !== undefined)
      .filter((leg) => includeLeg(g, leg))
      .flatMap((leg) =>
        leg.timeSlots.map((slot) => ({
          areaCode: leg.areaCode,
          timeCode: slot.timeCode,
          direction: leg.direction,
          volumeMwh: slot.volumeMwh?.value ?? '0',
        })),
      ),
  )
